(function(){
    'use strict'

    angular
    .module('app.servicios')
    .controller('servicios.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        ApiBaseService.remoteController = 'api/Servicios'

        const companiaId = UserInfoService.getCompaniaId();

        var vm = this;

        vm.collection = [];
        vm.title = 'Servicios';

        vm.goToEdit = function(data){
            
            var path = '/editar-servicio/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = ApiBaseService.getAll([companiaId]);

            promise
            .then(function(collection){
                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

    }
})();